import get from "lodash/get";
export const parseDropdown = (
  collection: Array<any>,
  labelKey = "",
  valueKey = "",
  uppercase = false
) => {
  let parsedRecords = collection.map((item) => ({
    label: uppercase
      ? get(item, labelKey || "name") &&
        get(item, labelKey || "name").toUpperCase()
      : get(item, labelKey || "name") ||
        get(item, labelKey || "names") ||
          get(item, labelKey || "display_name") ||
        get(item, labelKey || "kpi_name"),
    value: get(item, valueKey || "id"),
  }));

  return parsedRecords;
};

export const parseKPIOptions = (
  collection: Array<any>,
  labelKey = "",
  valueKey = "",
  uppercase = false
) => {
  let parsedRecords = collection.map((item) => ({
    label: get(item, labelKey || "kpi_name"),
    value: get(item, valueKey || "kpi_id"),
  }));

  return parsedRecords;
};

export const parseScorecards = (
  collection: Array<any>,
  labelKey = "",
  valueKey = "",
  uppercase = false
) => {
  let parsedRecords = collection.map((item) => ({
    label: get(item, labelKey || "display_name"),
    value: get(item, valueKey || "id"),
  }));

  return parsedRecords;
};
export const parseGroupform = (
  collection: Array<any>,
  labelKey = "",
  emailKey = "",
  valueKey = "",
  uppercase = false
) => {
  let parsedRecords = collection.map((item) => ({
    label: get(item, labelKey || "names"),
    email: get(item, emailKey || "email"),
    value: get(item, valueKey || "id"),
  }));

  return parsedRecords;
};